import { render } from "./AgrupadosFormaPago.vue?vue&type=template&id=b067bc32&scoped=true"
import script from "./AgrupadosFormaPago.vue?vue&type=script&lang=js"
export * from "./AgrupadosFormaPago.vue?vue&type=script&lang=js"

import "./AgrupadosFormaPago.vue?vue&type=style&index=0&id=b067bc32&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b067bc32"]])

export default __exports__